import VueCookie from "vue-cookie";
import config from "../../public/config";

// 진행 중인 API 요청을 저장할 캐시
const promiseCache = new Map();

export const getFieldLabel = () => {
  const domain = window.location.hostname;
  switch (domain) {
  case "ep.maot.co.kr":
    return "작업장명";
  case "nhsafe.maot.co.kr":
    return "현장명";
  default:
    return "사업장명";
  }
};

export const formatPhone = (phone) => {
  if (!phone) return "";

  const cleanNum = phone.replace(/-/g, "");

  if (cleanNum.length === 10) {
    if (cleanNum.startsWith("02")) {
      return cleanNum.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
    } else {
      return cleanNum.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }
  } else if (cleanNum.length === 11) {
    return cleanNum.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }

  return cleanNum;
};

export const downloadFile = (fileName, path) => {
  const hashedFileName = path.split("/").pop();

  const token = VueCookie.get("token");
  fetch(`${config.BASE_API_URL}/api/v1/file?hashedName=${hashedFileName}`, {
    headers: new Headers({
      Authorization: `Bearer ${token}`,
    }),
  }).then((response) => {
    response.blob().then((myBlob) => {
      const url = window.URL.createObjectURL(myBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    });
  });
};


// post.post_contents 값이 존재하는 경우,
// 여기에는 [{post_id, data_key, data_value}, ...] 형태로 데이터가 들어있다.
// data_key 예시 : body.inspectList_1[6].isChecked
// 이 값들을 하나의 오브젝트로 합쳐서 반환한다.
export const mergePostContents = (post) => {
  if (!post || !post.post_contents || !Array.isArray(post.post_contents)) return {};

  const postContents = post.post_contents;
  if (!postContents || postContents.length === 0) return {};

  const merged = {};
  postContents.forEach((content) => {
    const key = content.data_key;
    const value = content.data_value;
    if (key && value !== undefined) {
      const keys = key.split(".");
      let target = merged;
      keys.forEach((k, i) => {
        const arrayMatch = k.match(/(.+)\[(\d+)]$/); // 배열 키 매칭
        if (arrayMatch) {
          const arrayKey = arrayMatch[1];
          const index = parseInt(arrayMatch[2], 10);

          // 배열 초기화
          if (!target[arrayKey]) target[arrayKey] = [];
          if (!Array.isArray(target[arrayKey])) throw new Error(`${arrayKey} is not an array`);

          // 배열 인덱스에 null 체크
          if (!target[arrayKey][index]) target[arrayKey][index] = i === keys.length - 1 ? value : {}; // 마지막 키일 경우 값 할당
          target = target[arrayKey][index]; // 다음 단계로 타겟 이동
        } else {
          // 객체 초기화
          if (i === keys.length - 1) {
            target[k] = value; // 마지막 키에 값 할당
          } else {
            if (!target[k] || target[k] === null) target[k] = {}; // 객체 초기화
            target = target[k];
          }
        }
      });
    }
  });

  return merged;
};

/**
 * Levenshtein 거리 계산 함수 (두 문자열 간 유사도 측정)
 * @param a 문자열 a
 * @param b 문자열 b
 * @returns {any}
 */
export function computeLevenshteinDistance(a, b) {
  const matrix = Array.from({ length: a.length + 1 }, (_, i) => Array(b.length + 1).fill(0));

  for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
  for (let j = 0; j <= b.length; j++) matrix[0][j] = j;

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,       // 삭제
        matrix[i][j - 1] + 1,       // 삽입
        matrix[i - 1][j - 1] + cost // 치환
      );
    }
  }
  return matrix[a.length][b.length];
}

// 캐시 키 생성 함수
const createCacheKey = (apiType, options) => {
  return `${apiType}:${JSON.stringify(options)}`;
};

const _loadDefragmentation = async ($store, apiType, options) => {
  const response = await $store.dispatch(apiType, options);
  const list = [];
  list.push(...response.data);
  if (response.current_page !== response.last_page) {
    const nextOptions = { ...options, page: response.current_page + 1 };
    list.push(...await _loadDefragmentation($store, apiType, nextOptions));
  }
  return list;
};

/**
 * 모든 페이지의 데이터를 불러온다.
 * @param $store
 * @param apiType
 * @param options
 * @returns {Promise<*[]>}
 */
export async function loadDefragmentation($store, apiType, options = {}) {
  const cacheKey = createCacheKey(apiType, options);
  // 진행 중인 동일한 요청이 있는지 확인
  if (!promiseCache.has(cacheKey)) {
    // 새로운 요청 생성 및 캐시에 저장
    const promise = _loadDefragmentation($store, apiType, { ...options })
      .finally(() => {
        // 요청 완료 후 일정 시간이 지나면 캐시에서 제거 (선택적)
        setTimeout(() => {
          promiseCache.delete(cacheKey);
        }, 30000); // 30초 후 캐시 제거
      });

    promiseCache.set(cacheKey, promise);
  }

  // 캐시된 Promise 반환
  return promiseCache.get(cacheKey);
}



export const listTableMethods = {
  getContent: (data) => {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
  getCreatedDate: (data) => {
      if (data === "") return "";
      return new Date(data).format("yyyy-MM-dd");
    },
  getCompanyName: (comId) => {
      for (const com of this.listCompanyList) {
        if (com.id === comId) {
          return com.com_name;
        }
      }
    },
  getContentTargetList: (list) => {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.target)) {
          result += `${data.target},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
  onNameBlur: (name) => {
      const length = name.length;
      if (length > 2) {
        const first = name[0];
        const last = name[name.length - 1];
        let star = "";
        for (let index = 0; index < length - 2; index++) {
          star += "*";
        }
        name = first + star + last;
      } else if (length === 2) {
        const first = name[0];
        name = `${first}*`;
      }
      return name;
    },
  getContentRiskList: (list) => {
      let result = "";
      for (const data of list) {
        if (data.input_3) {
          if (typeof data.input_3 === "string") {
            if (!result.includes(data.input_3)) {
              result += `${data.input_3},`;
            }
          }

          if (typeof data.input_3 === "object") {
            const temp = data.input_3.toString().split(",");
            for (const t of temp) {
              if (t && !result.includes(t)) {
                result += `${t},`;
              }
            }
          }
        }
      }
      return result.substring(0, result.length - 1);
    },
  getContentStringList: (list) => {
      let result = "";
      for (const data of list) {
        if (!result.includes(data)) {
          result += `${data},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
  comma: (str) => {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

  findJsonDataWithDottedPath(json, path) {
    try {
      const _keys = Object.keys(json);
      if (_keys.length === 0) {
        return "";
      }
      const paths = path.split(".");
      let result = json;
      for (const p of paths) {
        result = result[p];
      }
      return result;
    } catch (err) {
      return "";
    }
  },
}
